import React from 'react'
import { TopicNotSelectedGuard } from '../../share/guards'
import FilterContradictoryGuard from './FilterContradictoryGuard'
import { GuardProps } from '../types'

const DomainsWidgetSettingGuards = ({ widgetId, children }: GuardProps): React.ReactElement => (
  <TopicNotSelectedGuard widgetId={widgetId}>
    <FilterContradictoryGuard widgetId={widgetId}>{children}</FilterContradictoryGuard>
  </TopicNotSelectedGuard>
)

export default DomainsWidgetSettingGuards
